const VALIDATION_MODULE_PROVIDERS = [];

export {VALIDATION_MODULE_PROVIDERS};
